import { LANGUAGES } from 'state/intl/types';
import { ILocalizedMenuEntry } from 'state/unified-menu/types';

import { OneMenuCatalogEntry } from './use-one-menu-catalog';

type LocalizedField = { locale?: string | null; fr?: string | null } | null | undefined;

function pickLocale(field: LocalizedField, language: LANGUAGES): string | undefined {
  if (!field) {
    return undefined;
  }
  if (language === LANGUAGES.fr) {
    return field.fr || field.locale || undefined;
  }
  return field.locale || field.fr || undefined;
}

/**
 * Maps a store-less OneMenu entry into the localized shape PDP info components expect
 * (`name.locale`, `description.locale`, …), honoring the active language.
 */
export function asPreviewMenuEntry(
  entry: OneMenuCatalogEntry,
  language: LANGUAGES
): ILocalizedMenuEntry {
  return ({
    ...entry,
    name: entry.name ? { locale: pickLocale(entry.name, language), fr: entry.name.fr } : entry.name,
    description: entry.description
      ? { locale: pickLocale(entry.description, language), fr: entry.description.fr }
      : entry.description,
    image: entry.image
      ? {
          ...entry.image,
          altText: entry.image.altText
            ? {
                locale: pickLocale(entry.image.altText, language),
                fr: entry.image.altText.fr,
              }
            : entry.image.altText,
        }
      : entry.image,
  } as unknown) as ILocalizedMenuEntry;
}
